import { KINDS } from '../helper';
export const kindMap = new Map([[KINDS.DEFAULT, {
  background: 'var(--neutral-surface-high-emphasis)',
  color: 'var(--neutral-text-high-emphasis)'
}], [KINDS.SUCCESS, {
  background: 'var(--success-surface-high-emphasis)',
  color: 'var(--neutral-text-inverse)'
}], [KINDS.DANGER, {
  background: 'var(--danger-surface-high-emphasis)',
  color: 'var(--neutral-text-inverse)'
}]]);